export const EXAM_TYPE_PRESETS = [
  { label: "Unit Test", value: "UNIT_TEST" },
  { label: "Monthly Test", value: "MONTHLY_TEST" },
  { label: "Quarterly", value: "QUARTERLY" },
  { label: "Half Yearly", value: "HALF_YEARLY" },
  { label: "Annual", value: "ANNUAL" },
] as const;
